import React from "react";
import { brand } from "../../brand";
import { isNativeApp } from "../../lib/platform";

const AppleGlyph = ({ size = 22 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M17.05 12.54c-.02-2.02 1.65-2.99 1.72-3.04-.94-1.37-2.4-1.56-2.92-1.58-1.24-.13-2.42.73-3.05.73-.63 0-1.6-.71-2.63-.69-1.35.02-2.6.79-3.29 2-1.4 2.43-.36 6.02 1.01 7.99.67.96 1.47 2.04 2.51 2 1.01-.04 1.39-.65 2.61-.65 1.22 0 1.56.65 2.63.63 1.09-.02 1.78-.98 2.44-1.95.77-1.12 1.09-2.2 1.11-2.26-.02-.01-2.13-.82-2.15-3.26zM15.1 6.36c.56-.68.93-1.62.83-2.56-.8.03-1.78.53-2.36 1.21-.52.6-.97 1.56-.85 2.48.89.07 1.81-.45 2.38-1.13z" />
  </svg>
);

const PlayGlyph = ({ size = 20 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true">
    <path d="M3.6 2.3 13.5 12 3.6 21.7c-.36-.2-.6-.58-.6-1.05V3.35c0-.47.24-.85.6-1.05z" fill="#5BC9F9" />
    <path d="M17.3 8.2 13.5 12l3.8 3.8 3.4-1.96c.86-.5.86-1.72 0-2.22L17.3 8.2z" fill="#FDDC00" />
    <path d="m3.6 2.3 9.9 9.7 3.8-3.8L6.2 1.66c-.9-.52-1.98-.24-2.6.64z" fill="#4DE898" />
    <path d="M13.5 12 3.6 21.7c.62.88 1.7 1.16 2.6.64l11.1-6.54L13.5 12z" fill="#FF3A44" />
  </svg>
);

function Badge({ href, glyph, top, name }) {
  const live = Boolean(href);
  const inner = (
    <span className="flex items-center gap-3">
      <span className="text-mist">{glyph}</span>
      <span className="flex flex-col text-left leading-none">
        <span className="text-[10px] font-medium uppercase tracking-wide text-mist-muted">
          {live ? top : "Coming soon to"}
        </span>
        <span className="mt-0.5 text-[15px] font-semibold text-mist">{name}</span>
      </span>
    </span>
  );
  const base =
    "inline-flex items-center rounded-2xl border border-white/12 bg-white/[0.04] px-5 py-2.5 backdrop-blur-md transition-all duration-300";
  if (!live) {
    return (
      <span
        data-testid={`store-badge-${name.toLowerCase().replace(/\s+/g, "-")}-soon`}
        className={`${base} cursor-default opacity-60`}
      >
        {inner}
      </span>
    );
  }
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={`store-badge-${name.toLowerCase().replace(/\s+/g, "-")}`}
      className={`${base} hover:-translate-y-0.5 hover:border-white/25 hover:bg-white/[0.07]`}
    >
      {inner}
    </a>
  );
}

export default function StoreBadges({ className = "" }) {
  const { appStore, playStore } = brand.stores || {};
  const showPlay = !isNativeApp(); // don't advertise Google Play from inside the iOS app
  return (
    <div className={`flex flex-wrap items-center justify-center gap-3 ${className}`} data-testid="store-badges">
      <Badge href={appStore} glyph={<AppleGlyph />} top="Download on the" name="App Store" />
      {showPlay && <Badge href={playStore} glyph={<PlayGlyph />} top="Get it on" name="Google Play" />}
    </div>
  );
}
